import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class DemissaoFuncionariosService {

  constructor(
    private http: HttpService,
    
    ) { }

  buscaFuncionarios(params:any, successHandle:Function, errorHandle:Function) {
    this.http.doGet('/employee', params,successHandle,errorHandle);
 }

 saveDismiss(data:any, successHandle:Function, errorHandle:Function){
   
   return this.http.doPost('/employee/dismiss',data,successHandle,errorHandle);
 }
    
}
